// Mirrors ClinicalFlag::COLOR_* constants on the backend.
export const CLINICAL_FLAG_COLOR_DEFAULT = 0;
export const CLINICAL_FLAG_COLOR_GREEN = 1;
export const CLINICAL_FLAG_COLOR_PURPLE = 2;
export const CLINICAL_FLAG_COLOR_BLUE = 3;
export const CLINICAL_FLAG_COLOR_RED = 4;
export const CLINICAL_FLAG_COLOR_ORANGE = 5;

// COLOR_RED/COLOR_ORANGE reuse the existing danger/warning palette instead of introducing duplicates.
const COLOR_SUFFIXES = {
    [CLINICAL_FLAG_COLOR_GREEN]: 'green',
    [CLINICAL_FLAG_COLOR_PURPLE]: 'purple',
    [CLINICAL_FLAG_COLOR_BLUE]: 'blue',
    [CLINICAL_FLAG_COLOR_RED]: 'danger',
    [CLINICAL_FLAG_COLOR_ORANGE]: 'warning',
};

/**
 * Resolve the svg classes of a clinical flag marker.
 * An explicitly configured flag color wins; otherwise the caller's legacy
 * rating/priority based fallback is kept.
 *
 * @param item     clinical flag as exported by the API
 * @param fallback {path, symbol} classes used when the flag has no explicit color
 */
export const clinicalFlagColorClasses = (item, fallback) => {
    const suffix = COLOR_SUFFIXES[item && item.color];
    if (!suffix) {
        return fallback;
    }
    return {path: `alert-bg-${suffix}`, symbol: `alert-symbol-${suffix}`};
};
